import {digitalDollarSvg as Icon__small__digitalDollarSvg} from '../Icon__small/Icon__small--digitalDollar.js';

export var digitalDollar = {
  name: 'digitalDollar',
  category: 'icon',
  colorable: true,
  svg: Icon__small__digitalDollarSvg,
};
